import { Link } from "react-router-dom";
import React from "react";
import ForexLogo from "../assests/ForexLogo.svg";
import { CandlestickChartIcon } from "lucide-react";

export default function Logo({ isExpanded }) {
  return (
    <Link to="/" className="flex items-center   ">
      <span className="flex font-semibold text-xl  text-white">
        {isExpanded ? (
          <div className="flex items-end space-x-3">
            <CandlestickChartIcon className="h-[28px] w-[28px] text-[#07F2C7]" />
            <span>Dashboard</span>
          </div>
        ) : (
          <CandlestickChartIcon className="h-[28px] w-[28px] text-[#07F2C7]" />
        )}
      </span>
    </Link>
  );
}
